<template>
  <el-dialog
    :title="title"
    :visible.sync="dialogFormVisible"
    style="z-index: 99"
    width="45vw"
    @close="handleClose"
  >
    <el-form ref="form" :model="form" label-width="90px" @submit.native.prevent>
      <!-- 包裹单号输入 -->
      <el-form-item label="包裹单号">
        <el-input
          ref="codeInput"
          v-model.trim="form.old_kr_code"
          autocomplete="off"
          clearable
          placeholder="请扫描或输入包裹单号，按回车确认"
          @keyup.enter.native="handleQuery"
          @keyup.space.native="handleSpaceInInput"
        />
      </el-form-item>

      <!-- 已扫描包裹列表（合箱场景） -->
      <el-form-item v-if="shippingType === 4 || shippingType === 7" label="已扫描包裹">
        <div v-for="(item, index) in scannedPackages" :key="index" class="package-tag">
          {{ item }}
        </div>
        <span v-if="scannedPackages.length === 0" style="color: #999">暂无扫描记录</span>
      </el-form-item>

      <!-- 全部包裹列表（合箱场景） -->
      <el-form-item v-if="shippingType === 4 || shippingType === 7" label="全部包裹">
        <div v-for="(item, index) in allPackageList" :key="index" class="package-tag">
          {{ item }}
        </div>
        <span v-if="allPackageList.length === 0" style="color: #999">暂无数据</span>
      </el-form-item>
    </el-form>

    <!-- 表格 -->
    <el-table
      :data="gridData"
      @selection-change="handleSelectionChange"
      style="width: 100%"
    >
      <!-- 多选列（分箱/合箱后分箱场景） -->
      <el-table-column
        v-if="shippingType === 3 || shippingType === 7"
        type="selection"
        width="40"
        align="center"
      />

      <!-- 包裹单号 -->
      <el-table-column prop="old_kr_code" label="包裹单号" min-width="150" />

      <!-- 部分出库开关（合箱场景） -->
      <el-table-column v-if="shippingType === 4" label="部分出库" width="100" align="center">
        <template #default="{ row }">
          <el-switch
            v-model="row.store_status"
            :active-value="2"
            :inactive-value="1"
          />
        </template>
      </el-table-column>

      <!-- 备注 -->
      <el-table-column label="备注" prop="remark" min-width="200">
        <template #default="{ row }">
          <el-input
            v-model="row.remark"
            size="small"
            placeholder="请输入备注"
            clearable
          />
        </template>
      </el-table-column>

      <!-- 操作 -->
      <el-table-column label="操作" width="80" align="center" fixed="right">
        <template #default="{ $index }">
          <el-button
            type="text"
            style="color: #f56c6c"
            size="small"
            @click="handleDeleteRow($index)"
          >
            移除
          </el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- 底部按钮 -->
    <div slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取 消</el-button>
      <el-button
        type="primary"
        :loading="printLoading"
        @click="handlePrintSheet"
      >
        打印面单
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import {
  OrderQuickDetail,
  orderNotice,
  combinedBoxCheck,
  orderOutbound,
} from '@/api/xgcApi'

export default {
  name: 'ScanDialog',

  props: {
    korType: {
      type: Number,
      default: 0,
    },
  },

  data() {
    return {
      // 弹窗相关
      title: '扫描单号',
      dialogFormVisible: false,

      // 表单数据
      form: {
        old_kr_code: '',
      },

      // 表格数据
      gridData: [],

      // 选中的行（分箱场景）
      selectedRows: [],

      // 发货方式：1-原箱 3-分箱 4-合箱 6-原箱 7-合箱后分箱
      shippingType: null,

      // 合箱场景数据
      scannedPackages: [], // 已扫描的包裹列表
      allPackageList: [], // 全部包裹列表
      combinedOrderId: '', // 合箱订单ID
      tempCode: '', // 合箱后拆箱临时code

      // 加载状态
      printLoading: false,

      // 防止重复提交
      isProcessing: false,
    }
  },

  mounted() {
    // 监听全局空格键（用于快捷打印）
    document.addEventListener('keydown', this.handleGlobalSpace)
  },

  beforeDestroy() {
    document.removeEventListener('keydown', this.handleGlobalSpace)
  },

  methods: {
    // ==================== 弹窗控制 ====================

    /**
     * 显示弹窗（由父组件调用）
     */
    showEdit(row) {
      this.resetAllData()
      this.dialogFormVisible = true
      this.$nextTick(() => {
        this.focusInput()
      })
    },

    /**
     * 关闭弹窗
     */
    handleClose() {
      this.dialogFormVisible = false
      this.resetAllData()
    },

    /**
     * 重置所有数据
     */
    resetAllData() {
      // 重置表单
      this.form = {
        old_kr_code: '',
      }

      // 重置表格数据
      this.gridData = []
      this.selectedRows = []

      // 重置合箱数据
      this.scannedPackages = []
      this.allPackageList = []
      this.combinedOrderId = ''
      this.tempCode = ''

      // 重置状态
      this.shippingType = null
      this.isProcessing = false
      this.printLoading = false

      // 重置表单验证状态
      if (this.$refs.form) {
        this.$refs.form.resetFields()
      }
    },

    /**
     * 聚焦到输入框
     */
    focusInput() {
      if (this.$refs.codeInput) {
        this.$refs.codeInput.focus()
      }
    },

    // ==================== 键盘事件 ====================

    /**
     * 全局空格键监听（快捷打印）
     * 仅在弹窗打开且焦点不在输入框时触发
     */
    handleGlobalSpace(event) {
      if (event.keyCode === 32 && this.dialogFormVisible) {
        // 如果焦点在输入框，不触发打印（由 handleSpaceInInput 处理）
        const target = event.target
        if (target.tagName === 'INPUT' || target.tagName === 'TEXTAREA') {
          return
        }
        event.preventDefault()
        this.handlePrintSheet()
      }
    },

    /**
     * 输入框中按空格键（仅阻止默认行为，不触发打印）
     */
    handleSpaceInInput(event) {
      event.stopPropagation()
    },

    // ==================== 扫码逻辑 ====================

    /**
     * 处理回车键（确认扫描）
     */
    handleQuery() {
      const code = this.form.old_kr_code
      if (!code) {
        this.$baseMessage('请输入或扫描包裹单号', 'warning')
        return
      }

      // 防止重复提交
      if (this.isProcessing) {
        return
      }

      this.isProcessing = true
      this.getParcelDetail()
    },

    /**
     * 查询包裹详情
     */
    async getParcelDetail() {
      try {
        const code = this.form.old_kr_code
        const res = await OrderQuickDetail({ old_kr_code: code })

        if (res.code !== 200) {
          this.$baseMessage(res.msg || '查询包裹失败', 'error')
          this.form.old_kr_code = ''
          this.isProcessing = false
          this.focusInput()
          return
        }


            // var submitFrom = {
            //   old_kr_code: code,
            //   type: 7,
            // }
            // combinedBoxCheck(submitFrom).then((req) => {
              
            // }).error((err=>{
            //   return
            // }))


        const data = res.data
        this.shippingType = data.shipping_type

        // 根据发货类型处理
        switch (this.shippingType) {
          case 1: // 原箱发货
          case 6: // 原箱发货
            await this.handleOriginalBox(data)
            break

          case 3: // 分箱发货
            await this.handleSplitBox(data)
            break

          case 4: // 合箱发货
            await this.handleCombinedBox(data)
            break

          case 7: // 合箱后分箱
            await this.handleCombinedThenSplit(data)
            break

          default:
            this.$baseMessage(`未知的发货类型: ${this.shippingType}`, 'error')
            this.shippingType = null
        }

        // 清空输入框并聚焦
        this.form.old_kr_code = ''
        this.focusInput()
        this.isProcessing = false
      } catch (error) {
        console.error('查询包裹失败:', error)
        this.$baseMessage('查询包裹失败，请重试', 'error')
        this.form.old_kr_code = ''
        this.isProcessing = false
        this.focusInput()
      }
    },

    // ==================== 各发货类型处理 ====================

    /**
     * 处理原箱发货 (shippingType: 1, 6)
     * 原箱：扫描后直接拉单+出库
     */
    async handleOriginalBox(data) {
      // 原箱发货直接拉单+出库
      const orderIds = [data.id]
      await this.pullAndOutbound(orderIds, {
        code: this.form.old_kr_code,
        type: 1, // 全部出库
      })
    },

    /**
     * 处理分箱发货 (shippingType: 3)
     * 分箱：展示分箱列表，用户选择后点击打印按钮批量出库
     */
    async handleSplitBox(data) {
      // 展示分箱列表
      this.gridData = data.fen.map(item => ({
        ...item,
        remark: item.remark || '',
      }))

      // 保存当前扫描的code，用于后续出库
      this.tempCode = this.form.old_kr_code

      this.$baseMessage(`分箱数据已加载，请选择要出库的包裹`, 'success')
    },

    /**
     * 处理合箱发货 (shippingType: 4)
     * 合箱：逐个扫描包裹，全部扫描完成后自动打印出库
     */
    async handleCombinedBox(data) {
      this.combinedOrderId = data.id

      // 获取全部包裹列表
      if (data.old_kr_code) {
        this.allPackageList = data.old_kr_code.split(',').filter(Boolean)
      }

      // 检查当前扫描的包裹是否在合箱列表中
      const currentCode = this.form.old_kr_code
      if (!this.allPackageList.includes(currentCode)) {
        this.$baseMessage('该包裹不在合箱列表中，请扫描正确的包裹', 'warning')
        this.shippingType = null
        return
      }

      // 检查是否已扫描
      if (this.scannedPackages.includes(currentCode)) {
        this.$baseMessage('该包裹已扫描，请勿重复扫描', 'warning')
        return
      }

      // 添加到已扫描列表
      this.scannedPackages.push(currentCode)

      // 添加到表格
      this.gridData.push({
        old_kr_code: currentCode,
        remark: '',
        store_status: 1, // 1-全部出库 2-部分出库
      })

      this.$baseMessage(`扫描成功 (${this.scannedPackages.length}/${this.allPackageList.length})`, 'success')

      // 如果所有包裹都已扫描，自动拉单+出库
      if (this.scannedPackages.length === this.allPackageList.length) {
        this.$baseMessage('所有包裹已扫描完成，自动出库', 'success')
        // 延迟执行，让用户看到提示
        setTimeout(() => {
          this.handleCombinedOutbound()
        }, 500)
      }
    },

    /**
     * 处理合箱后分箱 (shippingType: 7)
     */
    async handleCombinedThenSplit(data) {
      // 保存临时code
      this.tempCode = data.code

      // 获取全部包裹列表
      if (data.old_kr_code) {
        this.allPackageList = data.old_kr_code.split(',').filter(Boolean)
      }

      // 展示分箱数据
      if (data.fen && data.fen.length > 0) {
        this.gridData = data.fen.map(item => ({
          ...item,
          remark: item.remark || '',
        }))
        this.$baseMessage(`分箱数据已加载，请选择要出库的包裹`, 'success')
      } else {
        // 如果没有分箱数据，将当前扫描的包裹添加到列表
        const currentCode = this.form.old_kr_code
        if (!this.scannedPackages.includes(currentCode)) {
          this.scannedPackages.push(currentCode)
          this.gridData.push({
            old_kr_code: currentCode,
            remark: '',
          })
        }
      }
    },

    // ==================== 核心：拉单+出库 ====================

    /**
     * 拉单 + 出库（统一入口）
     * @param {Array} orderIds - 订单ID列表
     * @param {Object} outboundParams - 出库参数
     */
    async pullAndOutbound(orderIds, outboundParams) {
      if (!orderIds || orderIds.length === 0) {
        this.$baseMessage('没有可出库的订单', 'warning')
        return
      }

      try {
        this.printLoading = true

        // 1. 调用拉单接口
        const noticeData = {
          id: orderIds,
          type: 4,
        }
        const noticeRes = await orderNotice(noticeData)

        if (noticeRes.code !== 200) {
          this.$baseMessage(noticeRes.msg || '拉单失败', 'error')
          this.printLoading = false
          return
        }

        // 2. 调用出库接口
        const outRes = await orderOutbound(outboundParams)

        if (outRes.code === 200) {
          this.$baseMessage('出库成功', 'success')
          this.$emit('change', orderIds)

          // 清空数据并关闭弹窗
          this.resetAllData()
          this.dialogFormVisible = false
        } else {
          this.$baseMessage(outRes.msg || '出库失败', 'error')
        }

        this.printLoading = false
      } catch (error) {
        console.error('拉单出库失败:', error)
        this.$baseMessage('操作失败，请重试', 'error')
        this.printLoading = false
      }
    },

    // ==================== 分箱场景出库 ====================

    /**
     * 分箱/合箱后分箱 出库
     */
    async handleSplitOutbound() {
      if (this.selectedRows.length === 0) {
        this.$baseMessage('请选择要出库的包裹（勾选表格左侧复选框）', 'warning')
        return
      }

      // 提取选中的ID
      const selectedIds = this.selectedRows.map(item => item.id)

      // 构建备注数据
      const remarkMap = {}
      this.gridData.forEach(item => {
        if (item.remark) {
          remarkMap[item.id] = item.remark
        }
      })

      // 构建出库参数
      const outboundParams = {
        id: selectedIds,
        code: this.tempCode || this.form.old_kr_code,
        type: selectedIds.length === this.gridData.length ? 1 : 2, // 1-全部出库 2-部分出库
        shipping_type: this.shippingType,
        id_data: remarkMap,
      }

      // 调用拉单+出库
      await this.pullAndOutbound(selectedIds, outboundParams)
    },

    // ==================== 合箱场景出库 ====================

    /**
     * 合箱发货出库
     */
    async handleCombinedOutbound() {
      if (this.gridData.length === 0) {
        this.$baseMessage('没有可出库的包裹', 'warning')
        return
      }

      try {
        this.printLoading = true

        const codeList = this.gridData.map(item => item.old_kr_code)

        // 1. 合箱校验
        const checkRes = await combinedBoxCheck({
          order_id: this.combinedOrderId,
          old_kr_code: codeList.join(','),
          type: 4,
        })

        if (checkRes.code !== 200) {
          this.$baseMessage(checkRes.msg || '合箱校验失败', 'error')
          this.printLoading = false
          return
        }

        // 2. 拉单
        const noticeData = {
          id: [this.combinedOrderId],
          type: 4,
        }
        const noticeRes = await orderNotice(noticeData)

        if (noticeRes.code !== 200) {
          this.$baseMessage(noticeRes.msg || '拉单失败', 'error')
          this.printLoading = false
          return
        }

        // 3. 逐个出库
        const outboundPromises = this.gridData.map(item => {
          return orderOutbound({
            code: item.old_kr_code,
            type: item.store_status || 1,
            remark: item.remark || '',
          })
        })

        const results = await Promise.all(outboundPromises)

        // 检查是否全部成功
        const hasError = results.some(res => res.code !== 200)
        if (hasError) {
          this.$baseMessage('部分包裹出库失败，请检查', 'error')
          this.printLoading = false
          return
        }

        this.$baseMessage('全部出库成功', 'success')
        this.$emit('change', [this.combinedOrderId])

        // 清空数据并关闭弹窗
        this.resetAllData()
        this.dialogFormVisible = false
        this.printLoading = false
      } catch (error) {
        console.error('合箱出库失败:', error)
        this.$baseMessage('出库失败，请重试', 'error')
        this.printLoading = false
      }
    },

    // ==================== 打印面单（统一入口） ====================

    /**
     * 打印面单（实际是出库操作）
     */
    async handlePrintSheet() {
      // 防重复点击
      if (this.printLoading || this.isProcessing) {
        return
      }

      // 验证数据
      if (this.gridData.length === 0) {
        this.$baseMessage('请先扫描包裹', 'warning')
        return
      }

      // 分箱/合箱后分箱 - 需要选择
      if (this.shippingType === 3 || this.shippingType === 7) {
        await this.handleSplitOutbound()
        return
      }

      // 合箱发货
      if (this.shippingType === 4) {
        await this.handleCombinedOutbound()
        return
      }

      // 原箱发货 (理论上不会执行到这里，因为原箱在扫描时已自动出库)
      if (this.shippingType === 1 || this.shippingType === 6) {
        this.$baseMessage('原箱包裹已自动出库', 'info')
        return
      }

      this.$baseMessage('未知的发货类型', 'error')
    },

    // ==================== 表格操作 ====================

    /**
     * 多选变化
     */
    handleSelectionChange(val) {
      this.selectedRows = val
    },

    /**
     * 删除行
     */
    handleDeleteRow(index) {
      // 从表格删除
      const deletedItem = this.gridData[index]
      this.gridData.splice(index, 1)

      // 如果是合箱场景，从已扫描列表中移除
      if (this.shippingType === 4 && deletedItem) {
        const idx = this.scannedPackages.indexOf(deletedItem.old_kr_code)
        if (idx > -1) {
          this.scannedPackages.splice(idx, 1)
        }
      }

      // 如果表格为空，重置状态
      if (this.gridData.length === 0) {
        this.shippingType = null
        this.scannedPackages = []
        this.allPackageList = []
        this.combinedOrderId = ''
        this.tempCode = ''
        this.selectedRows = []
      }
    },
  },
}
</script>

<style scoped lang="scss">
.dialog-footer {
  text-align: right;
  padding-top: 10px;
}

.package-tag {
  display: inline-block;
  background: #f0f2f5;
  padding: 4px 12px;
  margin: 4px 8px 4px 0;
  border-radius: 4px;
  font-size: 13px;
  color: #333;

  &:last-child {
    margin-right: 0;
  }
}

:deep(.el-table) {
  margin-top: 10px;
}

:deep(.el-table .cell) {
  padding: 0 8px;
}

:deep(.el-switch) {
  .el-switch__core {
    width: 40px !important;
  }
}
</style>